import { render } from "./tg-bot-subscriber-form.component.vue?vue&type=template&id=72ccb262&scoped=true"
import script from "./tg-bot-subscriber-form.component.vue?vue&type=script&lang=js"
export * from "./tg-bot-subscriber-form.component.vue?vue&type=script&lang=js"

import "./tg-bot-subscriber-form.component.vue?vue&type=style&index=0&id=72ccb262&scoped=true&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ccb262"]])

export default __exports__